import {floor} from 'lodash'


export function resizeTextToFitBoundingBox(track){
  const sprite = track.sprites[0]
  return {
    ...track,
    sprites: [
      {
        ...sprite,
        fontSize: getAdjustFontSizeForSprite( sprite)
      }
    ]
  }
}

export function fitFontSizeToTracks(textTracks){
  const returnValues = []
  // eslint-disable-next-line no-unused-vars
  for (const track of textTracks){
    const sprite = track.sprites[0]

    // eslint-disable-next-line no-await-in-loop
    const fontSize =  getAdjustFontSizeForSprite( sprite)
    returnValues.push({track, fontSize})
  }
  return returnValues
}

export const createCssForMeasuringText = (sprite, overrideValues) => {
  const {
    fontFamily, fontSize, fontStyle, fontWeight,
    width, textAlign, textDecoration
  } = {...sprite, ...overrideValues}
  const [{lineHeight}] = sprite.richText?.value || [{lineHeight: 1.15}]

  const tWidth = `${width}px`

  const cssText = `
    width: ${tWidth};
    max-width: ${tWidth};
    min-width: ${tWidth};
    height: 'auto';
    font-style: ${fontStyle};
    font-weight: ${fontWeight};
    font-size: ${fontSize}px;
    font-family: ${fontFamily};
    overflow-wrap: break-word;
    position: absolute;
    text-decoration: ${textDecoration};
    text-align: ${textAlign};
    line-height: ${lineHeight};
    left: -999px;
    top: -999px;
    z-index: 9999;
  `

  return cssText
}

const element = document.createElement('div')
element.setAttribute('id', 'measureText')
document.getElementsByTagName('body')[0].appendChild(element)

export const measureTextRect = (sprite, overrideValues) => {
  const cssText = createCssForMeasuringText(sprite, overrideValues)
  element.style.cssText = cssText
  element.innerText = sprite.text

  const rect = element.getBoundingClientRect()

  return rect
}

function getAdjustFontSizeForSprite( sprite){
  let cont =true
  const {fontSize} = sprite
  const {height: targetHeight} = sprite
  const {height: measuredHeight} =  measureTextRect( sprite)

  let highLimit, lowLimit
  if (targetHeight> measuredHeight){
    lowLimit = {fontSize, measuredHeight}
    highLimit = {
      fontSize: 400,
      measuredHeight: measureTextRect( sprite, {fontSize: 400}).height
    }
  }
  else {
    lowLimit = {
      fontSize: 6,
      measuredHeight: measureTextRect( sprite, {fontSize: 6}).height
    }
    highLimit = {fontSize, measuredHeight}
  }

  while (cont )
  {
    const adjustForFontSize =  floor((highLimit.fontSize - lowLimit.fontSize)/2)
    if (adjustForFontSize === 0) {
      highLimit = lowLimit
      cont = false
      continue
    }

    const currentFontSize = lowLimit.fontSize + adjustForFontSize
    // eslint-disable-next-line no-await-in-loop
    const currentMeasuredHeight =  measureTextRect( sprite, {fontSize: currentFontSize}).height
    if (currentMeasuredHeight < targetHeight){
      lowLimit = {fontSize: currentFontSize, measuredHeight: currentMeasuredHeight}
    }
    else {
      highLimit = {fontSize: currentFontSize, measuredHeight: currentMeasuredHeight}
    }
    if (highLimit.measuredHeight < targetHeight) {
      cont = false
    }
  }

  return highLimit.fontSize
}

export const getTextWidth = (item) => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = window.getComputedStyle(document.body).font

  return context.measureText(item).width
}

export const getFontActualHeight = (font, fontSize) => {
  const allLetters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  ctx.font = `${fontSize}px ${font}`
  const fontBoundingBoxAscent = ctx.measureText(allLetters).fontBoundingBoxAscent
  const fontBoundingBoxDescent = ctx.measureText(allLetters).fontBoundingBoxDescent

  return {
    toTop: fontBoundingBoxAscent,
    toBottom: fontBoundingBoxDescent,
    offsetHeight: fontBoundingBoxAscent + fontBoundingBoxDescent
  }
}
